








import { Component, Prop, Vue } from 'vue-property-decorator'
import {MDCList} from '@material/list'
@Component({})
export default class MdcList extends Vue{
  @Prop({default:'div'}) tag!:string
  @Prop({default:false,type:Boolean})twoLine!:boolean
  @Prop({default:false,type:Boolean})avatar!:boolean
  mdcList_!:MDCList
  mounted(){
    this.mdcList_ = new MDCList(this.$el)
  }
  beforeDestroy(){
    this.mdcList_.destroy()
  }
}
